<script>
  // import { quest, quests } from "../taskTipStore.js";
  import { user } from "../userStore.js";  
  import { quests as questsDb } from "../taskTipStore.js";
  import { onMount, onDestroy } from 'svelte'

  // $: someTestJSON = JSON.stringify($quests, null, 2);

  let users = [];
  let currentUser = {};
  
  let quests = [];
  let currentQuest = {};

  let showStudentsOnlyWithMessages = false;
  // let showQuestOnlyWithMessages = false;

  let mockCreatedDate = 1593333725140;
  $: usersFiltered = users.filter(u => {
      if (showStudentsOnlyWithMessages) return u.unreadFromStudent > 0
      else return true;
    })
    .sort((a, b) => (b.created || mockCreatedDate) - (a.created || mockCreatedDate));

  $: questsFiltered = quests.filter(q => {
    if (showStudentsOnlyWithMessages) return q.unreadFromStudent > 0
    else return true;
  });

  onMount(() => {
    console.log("onMount");
    // let usersRef = firebase.database().ref("edulearn/users/info/").orderByChild('email').limitToLast(10); // не пущает
    // let usersRef = firebase.database().ref("edulearn/users/info/").orderByChild('email').equalTo('gressus@yandex.ru'); // не пущает
    // let usersRef = firebase.database().ref("edulearn/users/info/").orderByKey().equalTo('piVXohAGI9eteG6cnzfJhaykJ6D2'); // не пущает
    
    let refStudentByTeacherList = firebase.database().ref("edulearn/rules/userbyteacher");

    let teacherId = firebase.auth().currentUser.uid;
    // console.log('teacherId ' + JSON.stringify(firebase.auth().currentUser));
    let refTeacher = refStudentByTeacherList.child(teacherId);
    refTeacher.off();
    refTeacher.on("child_added", function(snap) {
        // console.log('userbyteacher: ' + snap.key);
        // let user = users.find(u => u.id == snap.key);
        // if (!user) return;
        // user.teacherIs = selected.id;
        // users = [...users];        


        let usersRef = firebase.database().ref("edulearn/users/list/").child(snap.key);
        usersRef.off();
        usersRef.once("value", (snap) => {
          let u = snap.val();
          let user = {
            
          }
          // console.log('+user (' + snap.key + ') ' + JSON.stringify(u));
          // console.log('+user (' + snap.key + ') ' + u);
          if (!u) {
            alert("Сообщите в поддержку, чтобы от преподавателя открепили вручную удаленного студента: " + snap.key);
          }
          users = [...users, snap.val()];
        });
        usersRef.on("child_changed", (snap2) => {
          // console.log("+user child_changed " + JSON.stringify(snap2));
          console.log("+user child_changed " + snap2.ref.key);
          // let changedUser = snap2.val();
          // let changedUser = snap.val();
          let foundUser = users.find(t => {
            // return t.id == changedUser.id
            return t.id == snap.key;
          });
          if (!foundUser) return;

          // foundUser.unreadFromTeacher = changedUser.unreadFromTeacher;
          // foundUser.unreadFromStudent = changedUser.unreadFromStudent;

          if (snap2.ref.key == "unreadFromTeacher") {
            foundUser.unreadFromTeacher = snap2.val();
          }

          if (snap2.ref.key == "unreadFromStudent") {
            foundUser.unreadFromStudent = snap2.val();
          }

          if (snap2.ref.key == "checkattemps") {
            foundUser.checkattemps = snap2.val();
          }          

          console.log("+foundUser");
          users = [...users];
        });        
        
    });

    refTeacher.on("child_removed", function(snap) {
        users = users.filter(u => u.id != snap.key);
        // let user = users.find(u => u.id == snap.key);
        // if (!user) return;
        // if (user) {
        //     user.isTeacher = null;
        //     users = [...users];
        // }        
    });

    let usersRef = firebase.database().ref("edulearn/users/list/");
  //   usersRef.on("child_added", (snap) => {
  //     let u = snap.val();
  //     let user = {
        
  //     }
  //     console.log("+user");
  //     users = [...users, snap.val()];
  //   });
  //   usersRef.on("child_changed", (snap) => {
  //     let changedUser = snap.val();
  //     let foundUser = users.find(t => {
  //       return t.id == changedUser.id
  //     });
  //     if (!foundUser) return;

  //     foundUser.unreadFromTeacher = changedUser.unreadFromTeacher;
  //     foundUser.unreadFromStudent = changedUser.unreadFromStudent;

  //     console.log("+foundUser");
  //     users = [...users];
  //   });
  });

  function selectUser(u) {
    // quest.setQuestId(id);
    currentUser = u;

    quests = [];
    quests = [...quests];
    currentQuest = {};
    user.setUserId(currentUser.id, 'none', false, false);

    // console.log("selectUser");
    let usersRef = firebase.database().ref("edulearn/users/info/" + currentUser.id + "/quests/");
    usersRef.on("child_added", (snap) => {
      let addedQuest = snap.val();
      // console.log(JSON.stringify(snap.key, null, 2))
      // console.log(JSON.stringify(addedQuest, null, 2))
      $questsDb; // нужно, чтобы предзагрузились все квесты со всеми задачами
      let q = {
        id: snap.key,
        unreadFromTeacher: addedQuest.unreadFromTeacher,
        unreadFromStudent: addedQuest.unreadFromStudent,
        checkattemps: addedQuest.checkattemps,
        name: questsDb.getNamebyId(snap.key) // todo fixme жутко не оптимизировано, загружаются все квесты сразу
      }
      // console.log("+user");
      quests = [...quests, q];
    });

    usersRef.on("child_changed", (snap) => {
      let changedQuest = snap.val();
      let foundQuest = quests.find(t => {
        return t.id == snap.key
      });
      if (!foundQuest) return;

      foundQuest.unreadFromTeacher = changedQuest.unreadFromTeacher;
      foundQuest.unreadFromStudent = changedQuest.unreadFromStudent;
      foundQuest.checkattemps = changedQuest.checkattemps;

      // console.log("+foundQuest " + JSON.stringify(changedQuest, null, 2));
      quests = [...quests];
    });
  }

  function selectQuest(quest) {
    currentQuest = quest;
    console.log("selectQuest");
    user.setUserId(currentUser.id, quest.id, false, false);
    // let questsRef = firebase.database().ref("edulearn/quests/" + currentQuest.id);
    // questsRef.once("value", (snap) => {
    //   let q = snap.val();
    //   console.log("quest");
    //   // quests = [...quests, snap.val()];
    // });
  }  

  function addQuest() {
    let newQuest = {
      //   id: Math.round(Math.random() * 1000000), // will autogenerate
      name: "Новый квест",
      tasks: [],
      tips: []
    };

    // quests.addQuest(newQuest);
  }
</script>

<style>
  button {
    background-color: #eee;
    border: 0;
    border-radius: 5px;
    color: #fff;
  }

  button.current {
    background-color: blue;
  }

  button.add {
    background-color: orangered;
  }

  .tooltip {
    position: relative;
    display: inline-block;
    /* border-bottom: 1px dotted black; */
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 220px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -110px;
    opacity: 0;
    transition: opacity 0.3s;
    font-size: small;
  }

  .tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  .badge {
    display: inline-block;
    min-width: 10px;
    padding: 3px 7px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    background-color: #777;
    border-radius: 10px;
  }

  .badge.unread {
    /* display: block; */
    position: absolute;
    top: -5px;
    left: -5px;
    background-color: red;
  }
</style>

<label>
  <input type="checkbox" bind:checked={showStudentsOnlyWithMessages} />
  showStudentsOnlyWithMessages
</label>
{#each usersFiltered as user, i (user.id)}
  <div class="tooltip">
    <button
      class:current={currentUser.id == user.id}
      on:click={() => selectUser(user)}>
      {#if user.checkattemps}
        ({user.checkattemps})
      {/if}             
      {user.name} ({user.id})
      {#if user.unreadFromStudent}
        <span class="badge unread">{user.unreadFromStudent}</span>
      {/if}               
    </button>
    <span class="tooltiptext">{user.id}</span>
  </div>
  <br />
{:else}
  Загружается список Юзерей...
  <br />
{/each}
<!-- <button class="add" on:click={() => addQuest()}>+</button> -->
<br><br>

<!-- <label>
  <input type="checkbox" bind:checked={showQuestOnlyWithMessages} />
  showQuestOnlyWithMessages
</label> -->
{#each questsFiltered as quest, i (quest.id)}
  <div class="tooltip">
    <button
      class:current={currentQuest.id == quest.id}
      on:click={() => selectQuest(quest)}>
      {#if quest.checkattemps}
        <!-- ({quest.checkattemps} / {quest.tasks.length}) -->
        ({quest.checkattemps})
      {/if}                     
      {quest.name} {quest.id}
      {#if quest.unreadFromStudent}
        <span class="badge unread">{quest.unreadFromStudent}</span>
      {/if}                     
    </button>
    <span class="tooltiptext">{quest.id}</span>
  </div>
  <br />
{:else}
  Загружается список Квестов...
  <br />
{/each}
